<template>
  <div class="container">
    <van-sticky>
      <PublicHeader :totalName="$t('finance').Loanrecords" />
      <!-- 顶部 -->
      <div class="top">
        <!-- tab切换 -->
        <div class="tabs"><span v-for="(item, index) in tabs" :key="`tab${index}`" :class="active == item.value ? 'active' : ''" @click="changeTab(item.value)">{{ item.name }}</span></div>
      </div>
    </van-sticky>
    <!-- 列表 -->
    <div class="listInfo">
      <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getLoanOrderList" :immediate-check="false">
        <div class="item" v-for="(dItem, dIndex) in oList" :key="`fiorder${dIndex}`" @click="toOrderInfo(dItem)">
          <div class="yield">
            <div class="left"> {{ $t('finance').LoanAmount }}</div>
            <div class="amount">{{ dItem.amount }} USDT</div>
          </div>
          <div class="time">{{ $t('finance').LoanDate }}<span>{{ dItem.createTime | getLocalTime }} </span></div>
        </div>
      </van-list>
    </div>
    <!-- 订单详情 -->
    <van-popup v-model="showOrderInfo" closeable position="bottom">
      <div class="orderInfo">
        <!-- 状态 -->
        <div class="status">{{
          orderInfo.status == 1 ? $t('finance').Pendingreview : orderInfo.status == 2 ? $t('finance').issued :
            orderInfo.status == 3 ? $t('finance').Repaid :
              orderInfo.status == 4 ? $t('finance').Rejected : '' }}
        </div>
        <!-- 日利息率 -->
        <!-- <div class="item">{{ $t('finance').Dailyinterestrate }}<span>{{ orderInfo.interest }}%</span></div> -->
        <!-- 期限 -->
        <!-- <div class="item">{{ $t('finance').term }}<span>{{ orderInfo.days }} {{ $t('finance').day }}</span></div> -->
        <!-- 借款金额 -->
        <div class="item">{{ $t('finance').LoanAmount }}<span>{{ orderInfo.amount }} USDT</span></div>
        <!-- 借款日 -->
        <div class="item">{{ $t('finance').LoanDate }}<span>{{ orderInfo.createTime | getLocalTime }}</span>
        </div>
        <!--到期日 -->
        <!-- <div class="item">{{ $t('finance').duedate }}<span>{{ orderInfo.maturityTime | getLocalDate }}</span></div> -->
        <!-- 总利息 -->
        <!-- <div class="item">{{ $t('finance').Totalinterest }}<span>{{ orderInfo.revenueAmount }} USDT</span></div> -->
        <!-- 应还金额 -->
        <!-- <div class="item">{{ $t('finance').AmountDue }}<span>{{ orderInfo.settleAmount }} USDT</span></div> -->
        <!-- 订单编号 -->
        <div class="item">{{ $t('position').orderno }} <span>{{ orderInfo.loanOrderNo }}</span></div>
        <!-- 还款 -->
        <div class="btn" v-if="orderInfo.status == 2" @click="goServe">{{ $t('finance').repayment }}</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import PublicHeader from '@/components/publicHeader'
import orderApi from '@/api/order'
import userApi from '@/api/user'
export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
      },
      oList: [],
      orderInfo: {},
      showOrderInfo: false,
      active: "1",
      tabs: [{
        "name": this.$t('finance').Pendingreview,
        "value": "1"
      }, {
        "name": this.$t('finance').issued,
        "value": "2"
      }, {
        "name": this.$t('finance').Repaid,
        "value": "3"
      }, {
        "name": this.$t('finance').Rejected,
        "value": "4"
      },
      ],
    }
  },
  mounted() {
    this.getLoanOrderList()
  },
  methods: {
    //切换
    changeTab(val) {
      this.active = val
      this.oList = []
      this.parms.pageNum = 1
      this.finished = false;
      this.getLoanOrderList()
    },
    // 获取贷款订单记录
    async getLoanOrderList() {
      if (this.isRun) return
      this.isRun = true
      this.parms.status = this.active
      const res = await orderApi.getLoanOrderList(this.parms)
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
    },
    //查看订单详情
    toOrderInfo(val) {
      this.orderInfo = val
      this.showOrderInfo = true
    },
    // 客服
    async goServe() {
      const res = await userApi.getMemberInfo()
      const encodedData = JSON.stringify({ name: res.user.memberId, email: res.user.memberName });
      location.href = 'chatlinkonline.html?metadata=' + encodedData
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);
  padding-bottom: 30px;

  .top {
    padding-top: 50px;
    width: 100%;
    background: var(--background_color);

    .tabs {
      padding: 0 15px;
      font-size: 14px;
      font-weight: bold;
      color: var(--ntext_color);
      border-bottom: 1px solid var(--info_color);
      width: 100%;
      overflow-x: auto;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      -ms-overflow-style: none;

      span {
        display: inline-block;
        text-align: center;
        padding: 12px 0;
        margin-right: 20px;
      }

      .active {
        color: var(--primary_color);
        padding-bottom: 10px;
        border-bottom: 2px solid var(--primary_color);
      }
    }
  }

  .listInfo {
    .item {
      padding: 15px;
      border-bottom: 1px solid var(--info_color);

      .name {
        font-size: 16px;
        color: var(--text_color);
      }

      .yield {
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
          font-size: 13px;
          color: var(--ntext_color);
        }

        .amount {
          font-size: 14px;
          font-weight: bold;
          color: var(--text_color);
        }
      }

      .time {
        margin-top: 10px;
        font-size: 13px;
        color: var(--ntext_color);
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }

  .orderInfo {
    padding: 30px 15px;

    .status {
      font-size: 15px;
      font-weight: bold;
      color: var(--primary_color);
      text-align: center;
    }

    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      font-size: 13px;
      color: var(--ntext_color);

      span {
        color: var(--text_color);
      }
    }

    .btn {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      border-radius: 20px;
      font-size: 15px;
      color: #fff;
      background: var(--primary_color);
    }
  }
}

::v-deep .van-popup--bottom {
  border-radius: 15px 15px 0 0;
  background: var(--background_color);
}

::v-deep .van-popup--center {
  border-radius: 15px;
  background: var(--background_color);
}

::v-deep .van-popup__close-icon {
  font-size: 18px;
  color: var(--ntext_color);
}
</style>
